import axios from "axios";
import { signOutRequest } from "../store/auth/authSlice";
import { BaseURL, CreateFormData, apiHeader } from "../config/apiUrl.js";
import moment from "moment";
import { toast } from "sonner";

const getHeaders = (accessToken) => ({
  Accept: "application/json",
  Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
  "ngrok-skip-browser-warning": "69420",
  "timezone-offset": moment().utcOffset(),
});

const handleError = (error, showAlert, dispatch) => {
  let errorMessage = "";
  if (Array.isArray(error?.response?.data?.message?.error)) {
    error?.response?.data?.message?.error?.forEach(
      (item) => (errorMessage += ` • ${item} \n`)
    );
  } else {
    errorMessage = error?.response?.data?.message?.error;
  }

  if (error.response?.status === 401) {
    dispatch?.(signOutRequest());
  }

  if (showAlert) {
    const message =
      error.message === "Network Error"
        ? `${error.message} : Please Check Your Network Connection`
        : errorMessage;
    toast.error(message, { position: "top-center" });
  }
};

export const Get = async (route, accessToken, showAlert, dispatch) => {
  const options = { headers: getHeaders(accessToken) };
  try {
    const response = await axios.get(route, options);
    return response;
  } catch (error) {
    handleError(error, showAlert ?? true, dispatch);
  }
};

const apiRequest = async (
  method,
  route,
  data,
  { headers },
  showAlert,
  dispatch
) => {
  const options = {
    method,
    url: route,
    ...(data && { data }),
    headers,
  };
  try {
    return await axios(options);
  } catch (error) {
    handleError(error, showAlert, dispatch);
  }
};

export const Post = (route, data, headers, showAlert, dispatch) => {
  const apiHeaders = headers || { headers: getHeaders() };
  return apiRequest("post", route, data, apiHeaders, showAlert ?? true, dispatch);
};

export const Patch = (route, data, headers, showAlert, dispatch) => {
  const apiHeaders = headers || { headers: getHeaders() };
  return apiRequest("patch", route, data, apiHeaders, showAlert ?? true, dispatch);
};

export const Put = (route, data, headers, showAlert, dispatch) => {
  const apiHeaders = headers || { headers: getHeaders() };
  return apiRequest("put", route, data, apiHeaders, showAlert ?? true, dispatch);
};

export const Delete = (route, headers, showAlert, dispatch) => {
  const apiHeaders = headers || { headers: getHeaders() };
  return apiRequest("delete", route, null, apiHeaders, showAlert ?? true, dispatch);
};
export const UploadFiles = async (data, access_token, key = "images") => {
  const url = BaseURL("media/upload");

  const formData = CreateFormData({});
  for (let i in data) {
    if (Array.isArray(data[i])) {
      for (let j in data[i]) {
        formData.append(key, data[i][j]);
      }
    } else {
      formData.append(key, data[i]);
    }
  }

  const response = await Post(url, formData, apiHeader(access_token));
  if (response !== undefined) {
    return response;
  }
};

export const UploadVideosToAwsBySignedUrl = async (
  urlsArray,
  files,
  setUploadProgress
) => {
  const promises = urlsArray.map((url, index) => {
    return axios.put(url, files[index], {
      headers: {
        "Content-Type": `video/${files[index]?.name?.split(".")[1]}`,
        "ngrok-skip-browser-warning": "69420",
      },
      onUploadProgress: (data) => {
        if (setUploadProgress) {
          const progress = Math.round((100 * data.loaded) / data.total);
          setUploadProgress((previous) => Math.max(previous, progress));
        }
      },
    });
  });
  return Promise.allSettled(promises);
};
export const uploadFile = async (selectedFiles) => {
  if (selectedFiles?.length === 0) return [];
  const params = {
    files: selectedFiles?.map((ele) => ({
      mimeType: ele?.name?.split(".").pop(),
      name: ele?.name,
    })),
  };
  const response = await Post(BaseURL("get-signed-url"), params);
  if (response) {
    const { urls, keys } = response.data;
    await UploadVideosToAwsBySignedUrl(urls, selectedFiles, () => {});
    return keys;
  } else {
    return null;
  }
};
export const uploadMedia = async (selectedFiles) => {
  if (selectedFiles?.length === 0) return [];
  const params = {
    files: selectedFiles?.map((ele) => ({
      mimeType: ele?.name?.split(".").pop(),
      name: ele?.name,
    })),
  };
  const apiUrl = BaseURL("get-signed-url");
  const response = await Post(apiUrl, params);
  if (response) {
    if (response.data?.urls?.length > 0) {
      await UploadImagesToAwsBySignedUrl(response.data.urls, selectedFiles);
    }
    return response.data?.keys;
  }
  return null;
};
const UploadImagesToAwsBySignedUrl = async (urlsArray, files) => {
  const promises = urlsArray.map((url, index) => {
    const contentType = files?.[index]?.name?.split(".").pop();
    return axios.put(url, files[index], {
      headers: {
        "Content-Type": contentType === "pdf" ? "application/pdf" : contentType,
        "ngrok-skip-browser-warning": "69420",
      },
    });
  });
  const response = await Promise.allSettled(promises);
  return response;
};
